import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TokenService } from 'src/app/services/token/token.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isCookieNoticeAccepted = this.token.isCookieAccepted();
  isToggleMenuVisble = false;
  isToggleMobileMenuVisble = false;
  constructor(
    private token: TokenService,
    public authServe: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  acceptCookie(): void {
    this.isCookieNoticeAccepted = true;
    this.token.setCookieAcceptanceStatus();
  }

  toggleMenu(): void {
    this.isToggleMenuVisble = !this.isToggleMenuVisble;
  }

  toggleMobileMenu(): void {
    this.isToggleMobileMenuVisble = !this.isToggleMobileMenuVisble;
  }

  login(event: MouseEvent): void {
    event.preventDefault();
    this.openLoginModal();
    this.toggleMenu();
  }

  openLoginModal(): void {
    this.authServe.openLoginModal();
  }

  openForgotPasswordModal(): void {
    this.authServe.openForgotPasswordModal();
  }

  openSignUpModal(): void {
    this.authServe.openSignUpModal();
  }

  signup(event: MouseEvent): void {
    event.preventDefault();
    this.openSignUpModal();
    this.toggleMenu();
  }

  logout(event: MouseEvent): void {
    event.preventDefault();
    this.authServe.logout();
    this.toggleMenu();
    this.router.navigate(['/home'])
      .finally(() => {
        location.reload();
      });
  }
}
